import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountContext } from '../context';
import { TabProps } from './layout.types';

const Tab: React.FC<TabProps> = ({
  slug,
  name,
  url = '',
  isTenantAdmin = false,
}) => {
  const { t } = useTranslation('library');
  const { focusedTab, setFocusedTab } = useContext(AccountContext);

  const handleTabClick = () => {
    if (url !== '') {
      window.open(url, '_blank');
    } else {
      setFocusedTab(slug);
    }
  };

  /*DONT SHOW ADMIN TAB WHEN USER ISN'T TENANT ADMIN */
  return slug === 'Admin' && !isTenantAdmin ? (
    <></>
  ) : (
    <a
      onClick={() => handleTabClick()}
      data-name={slug}
      id="w-node-_55e93cc5-bde5-75fc-1a12-721a10d6a710-8bfffe77"
      href="#"
      className={`account-tab-menu-element ${
        slug === focusedTab ? 'active' : ''
      }`}
    >
      {name}
    </a>
  );
};

export { Tab };
